const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgElle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3000 1227.7708",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000",
      fillRule: "evenodd",
      stroke: "none",
      strokeWidth: 1
    },
    transform: "matrix(13.466788,0,0,13.466788,20,20)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#000000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 6.7,86.8 -6.7,0 0,1.3 37.1,0 0,-23.4 -1.1,0 c 0,0 0,13.5 -4.5,17.9 -3.8,3.8 -7.8,4.1 -14.3,4.1 l 0,-43.1 c 0,0 4.5,-0.3 6.7,1.9 3.4,3.4 3.8,7.8 3.8,13.9 l 1.2,0 0,-33 -1.2,0 c 0,6.1 -0.3,10.5 -3.8,13.9 -2.2,2.2 -6.7,1.9 -6.7,1.9 l 0,-40.9 c 6.5,0 9.6,0.4 13.4,4.1 4.4,4.4 4.5,17.9 4.5,17.9 l 1.1,0 L 36.2,0 0,0 l 0,1.3 6.7,0 0,85.5 0,0 z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 79.2,1.3 0,85.5 c 6.5,0 10.5,-0.4 14.3,-4.1 C 97.9,78.3 98,64.8 98,64.8 l 1.1,0 0,23.4 -37.1,0 0,-1.3 6.7,0 0,-85.7 -6.7,0 0,-1.2 23.3,0 0,1.3 -6.1,0 0,0 z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 138.8,1.3 0,85.5 c 6.5,0 10.5,-0.4 14.3,-4.1 4.4,-4.4 4.5,-17.9 4.5,-17.9 l 1.1,0 0,23.4 -37.1,0 0,-1.3 6.7,0 0,-85.7 -6.7,0 0,-1.2 23.3,0 0,1.3 -6.1,0 0,0 z",
    style: {
      fill: "#000000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 189.4,86.8 -6.7,0 0,1.3 37.1,0 0,-23.4 -1.1,0 c 0,0 0,13.5 -4.5,17.9 -3.8,3.8 -7.8,4.1 -14.3,4.1 l 0,-43.1 c 0,0 4.5,-0.3 6.7,1.9 3.4,3.4 3.8,7.8 3.8,13.9 l 1.2,0 0,-33 -1.2,0 c 0,6.1 -0.3,10.5 -3.8,13.9 -2.2,2.2 -6.7,1.9 -6.7,1.9 l 0,-40.9 c 6.5,0 9.6,0.4 13.4,4.1 4.4,4.4 4.5,17.9 4.5,17.9 l 1.1,0 0,-23.3 -36.2,0 0,1.3 6.7,0 0,85.5 0,0 0,0 z",
    style: {
      fill: "#000000"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElle);
export default __webpack_public_path__ + "static/media/Elle.a5685b0ae1adae8e48ca8f6c9f514551.svg";
export { ForwardRef as ReactComponent };